import React, { useState } from 'react';
import { useTrackSection } from '../utils/useTrackSection';
import { trackCustom } from '../lib/pixel';
import { faqs } from '../lib/faqData';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  useTrackSection('faq', 'FAQ Section');
  return <section id="faq" className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    background: 'linear-gradient(180deg, rgb(240,253,244) 0%, rgb(220,252,231) 45%, rgb(240,253,244) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-116">
      <div className="mx-auto max-w-4xl" data-id="element-117">
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-118">
          Preguntas <span className="text-green-700" data-id="element-119">frecuentes</span>
        </h2>

        <p className="text-center text-sm text-gray-600 font-medium m-0 mb-8" data-id="element-120">
          Todo lo que necesitás saber antes de acceder al Megapack.
        </p>

        <div className="flex flex-col gap-2" data-id="element-121">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-white rounded-xl overflow-hidden shadow-sm transition-all" style={{
            border: isOpen ? '1px solid rgba(21,128,61,0.55)' : '1px solid rgba(21,128,61,0.18)'
          }} data-id="element-122">
                <button onClick={() => {
              const willOpen = !isOpen;
              setOpenIndex(isOpen ? null : i);
              if (willOpen) {
                trackCustom('FAQOpen', {
                  question: faq.question,
                  index: i
                });
              }
            }} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 text-left bg-transparent cursor-pointer border-0 px-5 py-4 m-0" style={{
              fontFamily: 'inherit'
            }} data-id="element-123">
                  <span className="text-sm font-bold" style={{
                color: isOpen ? '#15803d' : '#111827'
              }} data-id="element-124">
                    {i + 1}. {faq.question}
                  </span>

                  <span className="shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-white text-base font-black transition-transform duration-300" style={{
                backgroundColor: '#15803d',
                transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)'
              }} data-id="element-125">
                    +
                  </span>
                </button>

                {isOpen && <div className="px-5 pb-4" style={{
              borderTop: '1px solid rgba(21,128,61,0.1)'
            }} data-id="element-126">
                    <p className="text-sm text-gray-600 leading-relaxed m-0 pt-3" data-id="element-127">
                      {faq.answer}
                    </p>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}